import Vue from 'vue';
import Vuex from 'vuex';

import prefecture from '@/store/modules/prefecture';
import zipCode from '@/store/modules/zipCode';

import banner from '@/store/modules/banner';
import user from '@/store/modules/user';
import pack from '@/store/modules/pack';
import pointPrice from '@/store/modules/pointPrice';
import pay from '@/store/modules/pay';
import bank from '@/store/modules/bank';
import pointHistory from '@/store/modules/pointHistory';
import packHistory from '@/store/modules/packHistory';
import cardType from '@/store/modules/cardType';
import pending from '@/store/modules/pending';
import sms from '@/store/modules/sms';
import otherSite from '@/store/modules/otherSite';
import purchaseList from '@/store/modules/purchaseList';
import transferPoint from '@/store/modules/transferPoint';
import exchangeCard from '@/store/modules/exchangeCard';
import post from '@/store/modules/post';
import country from '@/store/modules/country';
import coupon from '@/store/modules/coupon';
import notice from '@/store/modules/notice';
import contact from '@/store/modules/contact';
import watchVideo from '@/store/modules/watchVideo';
import language from '@/store/modules/language';
import market from '@/store/modules/market';
import corporation from '@/store/modules/corporation';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    csrf: null,
    isLoading: false,
    userInfo: null,
    fullPath: null,
  },
  getters: {
    csrf: (state) => state.csrf,
    isLoading: (state) => state.isLoading,
    userInfo: (state) => state.userInfo,
    fullPath: (state) => state.fullPath,
  },
  actions: {
    setIsLoading({ commit }, isLoading) {
      commit('setIsLoading', isLoading);
    },
    setCsrf({ commit }, { csrfToken }) {
      commit('setCsrf', csrfToken);
    },
    setUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo);
    },
    setFullPath({ commit }, fullPath) {
      commit('setFullPath', fullPath);
    },
  },
  mutations: {
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setCsrf(state, csrf) {
      state.csrf = csrf;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setFullPath(state, fullPath) {
      state.fullPath = fullPath;
    },
  },
  modules: {
    banner,
    prefecture,
    zipCode,
    user,
    pack,
    pointPrice,
    pay,
    bank,
    purchaseList,
    pointHistory,
    packHistory,
    cardType,
    sms,
    otherSite,
    transferPoint,
    exchangeCard,
    post,
    country,
    coupon,
    notice,
    contact,
    watchVideo,
    language,
    pending,
    market,
    corporation,
  },
});
